'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Feiseanna = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = require('../events');

var _events2 = _interopRequireDefault(_events);

var _ngFileUpload = require('ng-file-upload');

var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);

var _fees = require('./fees');

var _fees2 = _interopRequireDefault(_fees);

var _ifeisIsomorphic = require('ifeis-isomorphic');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// FIXME(joshdmiller): for the temporary fee hacks below;
var LATE_FEE_NAME = 'Late Fee';
var ACCT_FEE_NAME = 'Family Fee';

var mixInFees = function mixInFees(feis, fees) {
  var late = fees.find(function (fee) {
    return fee.name === LATE_FEE_NAME;
  });
  var acct = fees.find(function (fee) {
    return fee.name === ACCT_FEE_NAME;
  });

  if (late) {
    feis.late_fee = late.amount;
  }

  if (acct) {
    feis.acct_fee = acct.amount;
  }

  return feis;
};

var credit_card_fee_template = {
  name: _ifeisIsomorphic.CREDIT_CARD_PROCESSING_FEE_NAME,
  trigger: 'Credit Card',
  // Valid level is (A)ccount or (P)erson.
  level: 'A',
  // Valid types are A(ccount), F(inance), R(egistration) or P(roduct).
  type: 'F',
  plural: true,
  amount: 0.30,
  percentage: 0.029
};

var Feiseanna = exports.Feiseanna = function () {
  function Feiseanna($q, $http, $rootScope, fEventService, Upload) {
    _classCallCheck(this, Feiseanna);

    this._ = {
      $q: $q,
      $http: $http,
      $rootScope: $rootScope,
      fEventService: fEventService,
      Upload: Upload
    };

    this._prefix = IFEIS_API_URI + '/api/feiseanna';
    this._textractPrefix = IFEIS_API_URI + '/api/textract/';
  }

  /**
   * Invitations
   */

  _createClass(Feiseanna, [{
    key: 'invite',
    value: function invite(uuid) {
      return this._.$http.get(this._prefix + '/invitations/' + uuid);
    }
  }, {
    key: 'invites',
    value: function invites() {
      return this._.$http.get(this._prefix + '/invitations');
    }
  }, {
    key: 'createInvite',
    value: function createInvite(invite) {
      return this._.$http.post(this._prefix + '/invitations', invite);
    }
  }, {
    key: 'invalidateInvite',
    value: function invalidateInvite(uuid) {
      return this._.$http.delete(this._prefix + '/invitations/' + uuid);
    }

    /**
     * Feiseanna
     */

  }, {
    key: 'create',
    value: function create(feis) {
      var _this = this;

      var feiseanna = void 0;

      return this._.$http.post(this._prefix, feis).then(function (feis) {
        feiseanna = feis;
        _this.notifyNew();
        return feis;
      }).then(function (feis) {
        return (0, _fees2.default)(feis.id, _this._.$http).create(credit_card_fee_template);
      }).then(function () {
        return feiseanna;
      });
    }
  }, {
    key: 'all',
    value: function all(params) {
      return this._.$http.get(this._prefix, params);
    }
  }, {
    key: 'one',
    value: function one(id) {
      var feis = void 0;

      var feesForFeis = (0, _fees2.default)(id, this._.$http);

      return this._.$http.get(this._prefix + '/' + id).then(function (f) {
        return feis = f;
      })

      // FIXME(joshdmiller): until the UI is updated to not use fixed fee types, we just hack it
      // together here.
      .then(function () {
        return feesForFeis.get();
      }).then(function (fees) {
        return mixInFees(feis, fees);
      });
    }
  }, {
    key: 'finalize',
    value: function finalize(id) {
      return this._.$http.post(this._prefix + '/' + id + '/finalize');
    }
  }, {
    key: 'uploadSyllabus',
    value: function uploadSyllabus(id, file) {
      return this._.Upload.upload({
        url: this._prefix + '/' + id + '/upload-syllabus',
        data: { file: file }
      });
    }

    /**
     * Attachment
     */

  }, {
    key: 'createAttachment',
    value: function createAttachment(id, file, name) {
      return this._.Upload.upload({
        url: this._prefix + '/' + id + '/attachments',
        data: { file: file, name: name }
      });
    }

    /**
     * createScoresheetPdf
     */

  }, {
    key: 'createScoresheetPdf',
    value: function createScoresheetPdf(Upload, id, file, name, aid, eid) {
      return Upload.upload({
        url: this._prefix + '/' + id + '/textract',
        data: { file: file, name: name, aid: aid, eid: eid }
      });
    }
  }, {
    key: 'getAttachments',
    value: function getAttachments(id) {
      return this._.$http.get(this._prefix + '/' + id + '/attachments');
    }
  }, {
    key: 'updateAttachment',
    value: function updateAttachment(id, attach_id, attachment) {
      return this._.$http.put(this._prefix + '/' + id + '/attachments/' + attach_id, attachment);
    }
  }, {
    key: 'deleteAttachment',
    value: function deleteAttachment(id, attach_id) {
      return this._.$http.delete(this._prefix + '/' + id + '/attachments/' + attach_id);
    }
  }, {
    key: 'publish',
    value: function publish(id) {
      return this._.$http.post(this._prefix + '/' + id + '/publish');
    }
  }, {
    key: 'unpublish',
    value: function unpublish(id) {
      return this._.$http.delete(this._prefix + '/' + id + '/publish');
    }
  }, {
    key: 'mine',
    value: function mine(id) {
      return this._.$http.get(this._prefix + '/mine');
    }
  }, {
    key: 'star',
    value: function star(id) {
      return this._.$http.post(this._prefix + '/' + id + '/star');
    }
  }, {
    key: 'update',
    value: function update(id, data) {
      var _this2 = this;

      var feis = void 0;

      var acct_fee = data.acct_fee,
          late_fee = data.late_fee,
          feisProps = _objectWithoutProperties(data, ['acct_fee', 'late_fee']);

      var feesForFeis = (0, _fees2.default)(id, this._.$http);

      return this._.$http.put(this._prefix + '/' + id, feisProps).then(function (f) {
        return feis = f;
      })

      // FIXME(joshdmiller): until the UI is updated to not use fixed fee types, we just hack it
      // together here.
      .then(function () {
        return feesForFeis.get();
      }).then(function (fees) {
        var late = void 0,
            acct = void 0,
            creditCard = void 0;
        late = fees.find(function (fee) {
          return fee.name === LATE_FEE_NAME;
        });
        acct = fees.find(function (fee) {
          return fee.name === ACCT_FEE_NAME;
        });
        creditCard = fees.find(function (fee) {
          return fee.name === _ifeisIsomorphic.CREDIT_CARD_PROCESSING_FEE_NAME;
        });

        if (!late && late_fee !== undefined) {
          late = feesForFeis.create({
            name: LATE_FEE_NAME,
            amount: late_fee,
            trigger: 'REG',
            level: 'A',
            type: 'A',
            comp_end: 'now',
            comp_start: 'dt_reg_late',
            comp_op: 'lt',
            prohibited: ['paid'],
            plural: false
          });
        } else if (late) {
          late = feesForFeis.update(late.id, { amount: late_fee });
        } else {
          late = _this2._.$q.resolve({});
        }

        if (!acct && acct_fee !== undefined) {
          acct = feesForFeis.create({
            name: ACCT_FEE_NAME,
            amount: acct_fee,
            trigger: 'REG',
            level: 'A',
            type: 'A',
            plural: false
          });
        } else if (acct) {
          acct = feesForFeis.update(acct.id, { amount: acct_fee });
        } else {
          acct = _this2._.$q.resolve({});
        }

        if (!creditCard) {
          creditCard = feesForFeis.create(credit_card_fee_template);
        } else {
          creditCard = _this2._.$q.resolve({});
        }

        return [late, acct, creditCard];
      }).then(function (fees) {
        return _this2._.$q.all(fees);
      }).then(function (fees) {
        return mixInFees(feis, fees);
      });
    }
  }, {
    key: 'resultsQueue',
    value: function resultsQueue(id) {
      var _this3 = this;

      return this._.$http.get(this._prefix + '/' + id + '/results-queue').then(function (events) {
        ['placements', 'recall'].forEach(function (k) {
          if (events[k]) {
            events[k] = events[k].map(function (event) {
              return _this3._.fEventService.deserializeEvent(event);
            });
          }
        });

        return events;
      });
    }

    /**
     * Templates
     */

  }, {
    key: 'templates',
    value: function templates() {
      return this._.$http.get(this._prefix + '/templates');
    }

    /**
     * Personnel
     */

  }, {
    key: 'grants',
    value: function grants(id, account_id) {
      return this._.$http.get(this._prefix + '/' + id + '/personnel/' + account_id);
    }
  }, {
    key: 'myGrants',
    value: function myGrants(id) {
      return this._.$http.get(this._prefix + '/' + id + '/personnel/me');
    }
  }, {
    key: 'personnel',
    value: function personnel(id) {
      return this._.$http.get(this._prefix + '/' + id + '/personnel');
    }
  }, {
    key: 'revokeGrant',
    value: function revokeGrant(id, grant_id) {
      return this._.$http.delete(this._prefix + '/' + id + '/personnel/' + grant_id);
    }
  }, {
    key: 'createGrant',
    value: function createGrant(id, grant) {
      return this._.$http.post(this._prefix + '/' + id + '/personnel', grant);
    }
  }, {
    key: 'teachers',
    value: function teachers(id) {
      return this._.$http.get(this._prefix + '/' + id + '/teachers');
    }

    /**
     * Schools
     */

  }, {
    key: 'schools',
    value: function schools(id) {
      return this._.$http.get(this._prefix + '/' + id + '/schools');
    }

    /**
     * Competitors
     */

  }, {
    key: 'competitors',
    value: function competitors(fid) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this._.$http.get(this._prefix + '/' + fid + '/competitors', { params: params });
    }
  }, {
    key: 'myCompetitors',
    value: function myCompetitors(fid) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this._.$http.get(this._prefix + '/' + fid + '/competitors', {
        params: _extends({}, params, {
          mine: true
        })
      });
    }

    /**
     * Prospects
     */

  }, {
    key: 'prospect',
    value: function prospect(fid, pid) {
      return this._.$http.get(this._prefix + '/' + fid + '/prospect/' + pid);
    }
  }, {
    key: 'prospects',
    value: function prospects(id, props) {
      return this._.$http.get(this._prefix + '/' + id + '/prospects', { params: props });
    }
  }, {
    key: 'participant',
    value: function participant(fid, num) {
      return this._.$http.get(this._prefix + '/' + fid + '/participants/' + num);
    }
  }, {
    key: 'placementsForParticipant',
    value: function placementsForParticipant(fid, pid) {
      var _this4 = this;

      return this._.$http.get(this._prefix + '/' + fid + '/placements/by-person/' + pid).then(function (events) {
        return events.map(function (event) {
          return _this4._.fEventService.deserializeEvent(event);
        });
      });
    }
  }, {
    key: 'scoresForParticipant',
    value: function scoresForParticipant(fid, pid) {
      var _this5 = this;

      return this._.$http.get(this._prefix + '/' + fid + '/scores/by-person/' + pid).then(function (events) {
        return events.map(function (event) {
          return _this5._.fEventService.deserializeEvent(event);
        });
      });
    }
  }, {
    key: 'accounts',
    value: function accounts(fid) {
      return this._.$http.get(this._prefix + '/' + fid + '/accounts');
    }
  }, {
    key: 'unpaidAccounts',
    value: function unpaidAccounts(fid) {
      return this._.$http.get(this._prefix + '/' + fid + '/accounts-without-payments');
    }
  }, {
    key: 'paidParticipants',
    value: function paidParticipants(fid) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      params.paid = true;
      return this._.$http.get(this._prefix + '/' + fid + '/competitors', { params: params });
    }
  }, {
    key: 'participantsBySchool',
    value: function participantsBySchool(fid) {
      return this._.$http.get(this._prefix + '/' + fid + '/participants-by-school');
    }

    /**
     * Adjudicators
     */

  }, {
    key: 'adjudicators',
    value: function adjudicators(fid) {
      if (fid) {
        return this._.$http.get(IFEIS_API_URI + '/api/feiseanna/' + fid + '/adjudicators');
      } else {
        return this._.$http.get(IFEIS_API_URI + '/api/adjudicators');
      }
    }
  }, {
    key: 'attachAdjudicator',
    value: function attachAdjudicator(fid, aid) {
      return this._.$http.post(IFEIS_API_URI + '/api/feiseanna/' + fid + '/adjudicators/' + aid);
    }
  }, {
    key: 'detachAdjudicator',
    value: function detachAdjudicator(fid, aid) {
      return this._.$http.delete(IFEIS_API_URI + '/api/feiseanna/' + fid + '/adjudicators/' + aid);
    }

    /**
     * Contacts
     */

  }, {
    key: 'contacts',
    value: function contacts(id) {
      return this._.$http.get(this._prefix + '/' + id + '/contacts');
    }
  }, {
    key: 'createContact',
    value: function createContact(fid, contact) {
      return this._.$http.post(this._prefix + '/' + fid + '/contacts', contact);
    }
  }, {
    key: 'updateContact',
    value: function updateContact(fid, cid, contact) {
      return this._.$http.put(this._prefix + '/' + fid + '/contacts/' + cid, contact);
    }
  }, {
    key: 'deleteContact',
    value: function deleteContact(fid, cid) {
      return this._.$http.delete(this._prefix + '/' + fid + '/contacts/' + cid);
    }

    /**
     * Accommodations
     */

  }, {
    key: 'accommodations',
    value: function accommodations(id) {
      return this._.$http.get(this._prefix + '/' + id + '/accommodations');
    }
  }, {
    key: 'createAccommodation',
    value: function createAccommodation(fid, accommodation) {
      return this._.$http.post(this._prefix + '/' + fid + '/accommodations', accommodation);
    }
  }, {
    key: 'updateAccommodation',
    value: function updateAccommodation(fid, aid, accommodation) {
      return this._.$http.put(this._prefix + '/' + fid + '/accommodations/' + aid, accommodation);
    }
  }, {
    key: 'deleteAccommodation',
    value: function deleteAccommodation(fid, aid) {
      return this._.$http.delete(this._prefix + '/' + fid + '/accommodations/' + aid);
    }
  }, {
    key: 'competitorNumberAssignmentMethods',
    value: function competitorNumberAssignmentMethods() {
      var methods = [{
        value: 'BY_LNAME',
        label: 'Assign alphabetically by last name'
      }, {
        value: 'BY_RDATE',
        label: 'Assign in order of when they registered'
      }];
      return methods;
    }
  }, {
    key: 'assignCompetitorNumbers',
    value: function assignCompetitorNumbers(fid) {
      return this._.$http.post(this._prefix + '/' + fid + '/assign-competitor-numbers');
    }

    /**
    * Notifications
    */

  }, {
    key: 'notifyNew',
    value: function notifyNew() {
      this._.$rootScope.$broadcast('feisAdded');
    }
  }]);

  return Feiseanna;
}();

exports.default = angular.module('ifeis.feiseanna', ['ifeis.events', _ngFileUpload2.default]).service('fFeisService', Feiseanna);


//////////////////
// WEBPACK FOOTER
// ./feiseanna/index.js
// module id = 24
// module chunks = 0